import { render, staticRenderFns } from "./ver.vue?vue&type=template&id=f5eddbb8&scoped=true&"
import script from "./ver.vue?vue&type=script&lang=js&"
export * from "./ver.vue?vue&type=script&lang=js&"
import style0 from "./ver.vue?vue&type=style&index=0&id=f5eddbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eddbb8",
  null
  
)

export default component.exports